// ==============================
//* ACCORDION
//
//? This file manages accordion behavior.
// ==============================

$(() => {
    const accordions = ".accordion";

    $(accordions).each(function (index) {
        let accordion = $(accordions)[index];
        let idAccordion = $(accordion).attr("id");

        // Set accordion Id in its items / data-parent
        $(accordion).find(".collapse").attr("data-parent", "#" + idAccordion);
    });
});
